import { IAutoMapper } from "../interfaces";

export const mapAuthorizationLetterAttribute = (automapper: IAutoMapper): void => {
  automapper
    .createMap("default", "AuthorizationLetterAttribute")
    .forMember("attributeName", o => o.attributeName)
    .forMember("attributeValue", o => o.attributeValue);

};
